<!--
 * @Author: Shen Kui
 * @LastEditTime: 2023-05-10 15:07:29
 * @Description:
-->
<template>
  <div>
    <div class="position-absolute" id="data-monitoring" v-if="showDeviceDetail" v-drag>
      <div class="h-100 w-100">
        <div class="w-100 h-100 content p-10">
          <div class="data-title position-relative">
            <div class="left-top-border"></div>
            <div class="fz-14 text-color-white p-l-20">智能联动</div>
            <i
              class="iconfont icon-close position-absolute cur_pointer text-color-white"
              @click="closeComponent"
            ></i>
          </div>
          <div class="env-monitoring w-100 p-10 position-relative">
            <el-table :data="monitorList" v-loading="tableLoading" class="w-100" height="100%">
              <el-table-column
                type="index"
                label="序号"
                align="center"
                width="55"
              ></el-table-column>
              <el-table-column prop="name" label="摄像头名称" align="center"></el-table-column>
              <el-table-column prop="distance" label="距离" align="center">
                <template #default="{row}">
                  <span>{{ row.distance + 'm' }}</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" align="center" width="80">
                <template #default="{row}">
                  <el-tooltip placement="top" content="播放" :open-delay="1000">
                    <el-button
                      type="success"
                      icon="el-icon-caret-right"
                      @click="runH5Player(row)"
                    ></el-button>
                  </el-tooltip>
                </template>
              </el-table-column>
            </el-table>
            <div class="right-bottom-border"></div>
          </div>
          <div class="data-title position-relative">
            <div class="left-top-border"></div>
            <div class="fz-14 text-color-white m-t-10 p-l-20">设备状态</div>
          </div>
          <div class="alarm-statistics w-100 p-10 position-relative fz-12 text-color-white">
            <el-row>
              <el-col :span="5">设备名称：</el-col>
              <el-col :span="19" class="ell">{{ baseInfo.name }}</el-col>
            </el-row>
            <el-row class="m-t-5">
              <el-col :span="5">所属系统：</el-col>
              <el-col :span="19" class="ell">风机控制子系统</el-col>
            </el-row>
            <el-row class="m-t-5">
              <el-col :span="5">通信状态：</el-col>
              <el-col :span="19" class="ell">{{
                moment().valueOf() % 2 === 0 ? '离线' : '在线'
              }}</el-col>
            </el-row>
            <el-row class="m-t-5">
              <el-col :span="5">报警信息：</el-col>
              <el-col :span="19" class="ell"
                >{{
                  moment()
                    .subtract(30, 'm')
                    .format('YYYY-MM-DD HH:mm:ss')
                }}
                设备连接断开</el-col
              >
            </el-row>
            <div class="right-bottom-border"></div>
          </div>
          <div class="data-title position-relative">
            <div class="left-top-border"></div>
            <div class="fz-14 text-color-white m-t-10 p-l-20">设备信息</div>
          </div>
          <div class="device-info w-100 p-10 position-relative fz-12 text-color-white">
            <div class="w-100 h-100 device-content">
              <el-row>
                <el-col :span="5">设备名称：</el-col>
                <el-col :span="19" class="ell">{{ baseInfo.name }}</el-col>
              </el-row>
              <el-row class="m-t-5">
                <el-col :span="5">设备编码：</el-col>
                <el-col :span="19" class="ell">{{ baseInfo.code }}</el-col>
              </el-row>
              <el-row class="m-t-5" v-for="item in generalAttrSet.attrValueList" :key="item.attrId">
                <el-col :span="5" class="ell tr">
                  <el-tooltip
                    effect="dark"
                    :content="item.attrbuteDetail.displayName"
                    placement="top"
                    :open-delay="1000"
                  >
                    <span>{{ item.attrbuteDetail.displayName }}：</span>
                  </el-tooltip>
                </el-col>
                <el-col :span="19" class="ell">{{ item.attrValue }}</el-col>
              </el-row>
            </div>
            <div class="right-bottom-border"></div>
          </div>
          <div class="data-title position-relative">
            <div class="left-top-border"></div>
            <div class="fz-14 text-color-white m-t-10 p-l-20">健康度评价</div>
          </div>
          <div class="status-statistics w-100 position-relative">
            <v-chart :options="healthEvaluation" class="h-100 w-100"></v-chart>
            <div class="right-bottom-border"></div>
          </div>
        </div>
      </div>
    </div>
    <!-- 监控弹框 -->
    <div
      class="h-100 position-absolute camera_info"
      :style="{ left: isShowBasicCom ? '405px' : '35px' }"
      v-if="showCamera"
      v-drag
    >
      <div class="camera_title fz-16 p-10 flex-row-between flex-align-center">
        <span class="fz-14 text-color-white">监控画面</span>
        <i class="cur_pointer iconfont icon-close text-color-white" @click="closePlayer"></i>
      </div>
      <h5-player
        v-if="switchPlayMonitor == 2"
        :showControl="true"
        class="play_wind"
        :isDarkStyle="true"
        :cameraIndexCodeList="cameraIndexCodeList"
      ></h5-player>
      <DH-player
        v-if="switchPlayMonitor == 3"
        :showControl="true"
        class="play_wind"
        :isDarkStyle="true"
        :cameraIndexCodeList="cameraIndexCodeList"
      ></DH-player>
    </div>
  </div>
</template>
<script>
import ApiMixinPoint from '@/assets/js/api/measuringPoint'
import MonitorManage from '@/services/monitorManage'
import h5Player from '@/components/video/h5Player'
import DHPlayer from '@/components/video/DHPlayer'
import ApiMixinDocumentList from '@/assets/js/api/documentList'
import TagService from '@/services/tags'
import DocumentManagementService from '@/services/documentManagement'

export default {
  name: 'DataMonitoring',
  components: {
    h5Player,
    DHPlayer,
  },
  mixins: [ApiMixinPoint, ApiMixinDocumentList],
  props: ['documentId', 'player', 'height', 'top', 'isShowBasicCom', 'fileId'],
  data() {
    return {
      systemParams: localStorage.getItem('systemParams')
        ? JSON.parse(localStorage.getItem('systemParams'))
        : [],
      baseInfo: [],
      generalAttrSet: [],
      showDeviceDetail: false,
      monitorList: [],
      tableLoading: false,
      showCamera: false,
      expireDevice: [],
      standbyDevice: [],
      defectDevice: [],
      fileRelationTag: [],
      cameraIndexCodeList: [],
      markerList: [],
      measurePointList: [],
      updateTimer: null,
      healthEvaluation: {
        radar: {
          // shape: 'circle',
          indicator: [
            { name: '型号', min: 0, max: 10 },
            { name: '位置', min: 0, max: 10 },
            { name: '健康级别', min: 0, max: 10 },
            { name: '健康情况', min: 0, max: 10 },
            { name: '处理建议', min: 0, max: 10 },
          ],
          name: {
            fontSize: 12,
            color: '#fff',
          },
          center: ['50%', '55%'],
          radius: '70%',
        },
        tooltip: {
          show: true,
        },
        series: [
          {
            type: 'radar',
            data: [
              {
                value: [0, 0, 0, 0, 0],
                name: '健康度',
                areaStyle: {
                  // 单项区域填充样式
                  normal: {
                    color: 'rgba(57,228,252,0.6)', // 填充的颜色。[ default: "#000" ]
                  },
                },
                itemStyle: {
                  color: 'rgb(57,228,252)',
                },
                label: true,
              },
            ],
          },
        ],
      },
    }
  },
  watch: {
    player: {
      handler(val) {
        if (val && val.Native) {
          this.initCom()
        }
      },
      deep: true,
    },
  },
  async created() {
    if (this.player && this.player.Native) {
      this.initCom()
    }
  },
  computed: {
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    switchPlayMonitor() {
      const switchPlayMonitor = _.find(this.systemParams, { parameterCode: 'switchPlayMonitor' })
      return switchPlayMonitor ? switchPlayMonitor.parameterValue : 1
    },
  },
  beforeDestroy() {
    this.clearMarker()
  },
  methods: {
    // 初始化组件
    async initCom() {
      await this.getExpireDevice()
      await this.getWorkStatusDevice()
      await this.getDefectDevice()
      await this.getFileRelationTag()
      this.groupedTag()
      this.getMonitorList()
      this.player.Native.GisMarker.EventGisMarkerLClick.connect(this.clickMarker)
    },
    // 获取到期设备
    async getExpireDevice() {
      const res = await TagService.getTagFilterNull({
        pageNo: 1,
        pageSize: 9999,
        siteId: this.currentProject.id,
        fliterNullAttributetFields: 'ExpireTime',
      })
      if (res && res.code === 0 && res.data) {
        this.expireDevice = _.filter(res.data.obsoleteDocumentList, (item) => {
          return (
            (item.doc_RemindTime && moment(item.doc_RemindTime).valueOf() <= moment().valueOf()) ||
            (item.doc_ExpireTime && moment(item.doc_ExpireTime).valueOf() <= moment().valueOf())
          )
        })
      }
    },
    // 获取工作状态有值
    async getWorkStatusDevice() {
      const res = await TagService.getTagFilterNull({
        pageNo: 1,
        pageSize: 9999,
        siteId: this.currentProject.id,
        fliterNullAttributetFields: 'WorkStatus',
      })
      if (res && res.code === 0 && res.data) {
        this.standbyDevice = _.filter(res.data.obsoleteDocumentList, (item) => {
          return item.doc_WorkStatus && item.doc_WorkStatus === '关闭'
        })
      }
    },
    // 获取缺陷设备
    async getDefectDevice() {
      const res = await TagService.getDeviceDefectList({
        pageNo: 1,
        pageSize: 9999,
        defectState: 0,
      })
      if (res && res.code === 0 && res.data) {
        this.defectDevice = res.data
      }
    },
    // 获取文件关联位号
    async getFileRelationTag() {
      if (this.fileId) {
        const res = await this.apiDocumentList({
          method: 'tagInfoByFile',
          params: {
            fileId: this.fileId,
            pageNo: 1,
            pageSize: 9999,
            keWord: ' ',
          },
          extra: { errorMsg: false },
        })
        if (res && res.dataList && res.success) {
          this.fileRelationTag = res.dataList
        }
      }
    },
    // 不同位号进行分类
    async groupedTag() {
      // 筛选到期的设备
      const expireList = _.filter(this.expireDevice, (item) => {
        return !_.isNil(_.find(this.fileRelationTag, ['tagId', item.id]))
      })
      const expireTags = _.map(expireList, (item) => {
        return { id: item.id, code: item.code, tagClassCode: item.classCode }
      })
      await this.drawGisMarker(expireTags, 1)
      // 筛选有缺陷的设备
      const defectList = _.filter(this.defectDevice, (item) => {
        return !_.isNil(_.find(this.fileRelationTag, ['tagId', item.tagId]))
      })
      _.remove(defectList, (item) => {
        return !_.isNil(_.find(expireList, ['id', item.tagId]))
      })
      const defectTags = _.map(defectList, (item) => {
        return { id: item.tagId, code: item.tagCode, tagClassCode: item.tagClassCode }
      })
      await this.drawGisMarker(defectTags, 2)
      // 筛选工作状态为关闭的设备
      const standbyList = _.filter(this.standbyDevice, (item) => {
        return !_.isNil(_.find(this.fileRelationTag, ['tagId', item.id]))
      })
      _.remove(standbyList, (item) => {
        return (
          !_.isNil(_.find(expireList, ['id', item.id])) &&
          !_.isNil(_.find(defectList, ['tagId', item.id]))
        )
      })
      const standbyTags = _.map(standbyList, (item) => {
        return { id: item.id, code: item.code, tagClassCode: item.classCode }
      })
      await this.drawGisMarker(standbyTags, 3)
      console.log(this.fileRelationTag, 111111)
      console.log(this.expireDevice, 2222222)
      console.log(this.defectDevice, 3333333)
      console.log(this.standbyDevice, 4444444)
      console.log(expireList, 555555)
      console.log(defectList, 666666)
      console.log(standbyList, 777777)
      if (this.$route.query.code) {
        const currentMarker = _.find(this.markerList, [
          'code',
          decodeURIComponent(this.$route.query.code),
        ])
        if (currentMarker) {
          this.clickMarker({ markerId: currentMarker.markerId })
        }
      }
    },
    // 绘制模型标签
    async drawGisMarker(tags, grade) {
      for (let i = 0; i < tags.length; i += 1) {
        let imgUrl = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/icon/${
          tags[i].tagClassCode
        }/${grade === 1 ? 'purple' : grade === 2 ? 'red' : 'white'}.png`
        const isExist = await this.player.Native.File.exists(imgUrl)
        if (!isExist) {
          imgUrl = `data://../apps/${currentEnv.VUE_APP_CURRENT_PROJECT}/icon/default/${
            grade === 1 ? 'purple' : grade === 2 ? 'red' : 'white'
          }.png`
        }
        const imgId = await this.player.Native.GisMarker.loadImage(imgUrl)
        const option = {
          visible: true, // 显示隐藏状态
          imgId, // 图片
          size: [50, 54], // 整体尺寸，二维向量，-1表示不限制，自动大小
          imgSize: [50, 54], // 图片尺寸，-1为应用图片大小，如[32, -1]为宽度拉伸或压缩到32，高度为图片高度
          imgOffset: [0, 0], // 图片相对标记的偏移量
          userData: null, // 用户数据，仅帮外部系统保存数据
        }
        const itemInfo = await this.player.Native.ModelTree.getItemByCode(tags[i].code)
        if (itemInfo.item) {
          const { aabb } = await this.player.Native.ModelTree.calcItemAabb(itemInfo.item)
          if (!_.isEmpty(aabb)) {
            const pos = [
              1 * aabb.min[0] + (aabb.max[0] - aabb.min[0]) / 2,
              1 * aabb.min[1] + (aabb.max[1] - aabb.min[1]) / 2,
              1 * aabb.max[2],
            ]
            option.pos = pos
            const markerId = await this.player.Native.GisMarker.create(option)
            this.markerList.push({
              id: tags[i].id,
              code: tags[i].code,
              markerId,
              grade,
            })
          }
        }
      }
    },
    // 关闭播放组件
    closePlayer() {
      this.showCamera = false
      this.cameraIndexCodeList = []
    },
    // 打开播放组件
    runH5Player(row) {
      this.showCamera = true
      this.cameraIndexCodeList.push(row.cameraIndexCode)
    },
    // 获取监控设备列表
    async getMonitorList() {
      const dataParams = {
        siteId: this.currentProject.id,
        pageno: 1,
        pagesize: 99999,
      }
      this.tableLoading = true
      this.monitorList = []
      const res = await MonitorManage.getMonitorList(dataParams)
      this.tableLoading = false
      if (res && res.code === 0 && res.data) {
        this.monitorList = _.map(res.data, (item) => {
          // 接收列表item
          return {
            id: item.id,
            name: item.name,
            cameraIndexCode: item.code,
            distance: 0,
          }
        })
      }
      console.log(res)
    },
    // 清除标记
    async clearMarker() {
      this.markerList = []
      const markers = await this.player.Native.GisMarker.getMarkerList()
      _.forEach(markers, async (item) => {
        await this.player.Native.GisMarker.destroy(item.id)
      })
      this.player.Native.GisMarker.EventGisMarkerLClick.disconnect(this.clickMarker)
      clearInterval(this.updateTimer)
    },
    // 点击标签
    async clickMarker(e) {
      this.showDeviceDetail = true
      const info = _.find(this.markerList, ['markerId', e.markerId])
      if (info.id) {
        const tagRes = await DocumentManagementService.editObjTransList({
          tagId: info.id,
        })
        if (tagRes && tagRes.code === 0 && tagRes.data) {
          this.baseInfo = tagRes.data.tag
          this.generalAttrSet = tagRes.data.generalAttrSet
        }
        this.healthEvaluation.series[0].data[0].value = [
          // eslint-disable-next-line no-nested-ternary
          info.grade === 1 ? _.random(3, 6) : info.grade === 2 ? _.random(8, 10) : 10,
          // eslint-disable-next-line no-nested-ternary
          info.grade === 1 ? _.random(3, 6) : info.grade === 2 ? _.random(8, 10) : 10,
          // eslint-disable-next-line no-nested-ternary
          info.grade === 1 ? 0 : info.grade === 2 ? _.random(5, 6) : 10,
          // eslint-disable-next-line no-nested-ternary
          info.grade === 1 ? 0 : info.grade === 2 ? _.random(5, 6) : 10,
          // eslint-disable-next-line no-nested-ternary
          info.grade === 1 ? 0 : info.grade === 2 ? _.random(8, 10) : 10,
        ]
      }
    },
    // 关闭弹窗
    closeComponent() {
      this.showDeviceDetail = false
    },
  },
}
</script>
<style lang="scss" scoped>

@import '../../css/select.scss';
@import '../../css/index.scss';
.content {
  overflow: auto;
}
.data-title {
  height: 40px;
  background-color: rgb(11, 44, 108);
  line-height: 40px;
  .icon-close {
    top: -10px;
    right: 3px;
  }
}
.left-top-border {
  height: 40px;
  width: 88px;
  position: absolute;
  left: 0;
  top: 0;
  background-image: url('/static/img/mk/left_top.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
.right-bottom-border {
  height: 40px;
  width: 88px;
  position: absolute;
  right: 0;
  bottom: 0;
  background-image: url('/static/img/mk/right_bottom.png');
  background-repeat: no-repeat;
  background-size: 100% 100%;
}
#data-monitoring {
  top: 65px;
  height: 815px;
  width: 368px;
  right: 35px;
  border-radius: 2px;
  z-index: 99;
  background-color: rgba(46, 107, 176, 0.5) !important;
  z-index: 99;
  .env-monitoring {
    background-color: rgba(24, 41, 72, 0.85);
    height: 140px;
  }
  .alarm-statistics {
    background-color: rgba(24, 41, 72, 0.85);
    height: 125px;
    overflow-y: auto;
  }
  .device-info {
    background-color: rgba(24, 41, 72, 0.85);
    height: 153px;
    .device-content {
      overflow-y: auto;
    }
  }
  .status-statistics {
    background-color: rgba(24, 41, 72, 0.85);
    height: 187px;
    .status-icon {
      padding: 0 20px;
      height: 36px;
    }
    .status-chart {
      height: calc(100% - 72px);
    }
  }
}
.field-temp {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgba(1, 255, 237, 0.76);
    display: flex;
    align-items: center;
  }
}
.field-humidity {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgba(112, 166, 219, 0.88);
    display: flex;
    align-items: center;
  }
}
.field-wind-speed {
  color: #ffffff;
  /deep/.el-card__body {
    background-color: rgb(255, 200, 22);
    display: flex;
    align-items: center;
  }
}
.text-color-red {
  color: red;
}
.camera_info {
  height: 395px;
  width: 720px;
  left: 378px;
  padding: 5px;
  top: 66px;
  z-index: 100;
  background-color: rgba(46, 107, 176, 0.5) !important;
}
.camera_title {
  height: 24px;
}
.play_wind {
  height: 360px;
}

</style>
